'use strict';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/distinctUntilChanged';
const angular = require('angular');
const {isArray, isDefined, isFunction, isObject, isString} = angular;

module.exports = [
  '$log',
  '$compile',
  '$templateRequest',
  '$animate',
  TransformerDirectiveFactory];

//TODO: add support for disabled mode watcher setting the directive to "bind once" style behavior
function TransformerDirectiveFactory(
  $log,
  $compile,
  $templateRequest,
  $animate,
) {
  var emptyTemplate = '<div style="display: none"></div>'; // questionable workaround for https://github.com/angular/angular.js/issues/4272

  /**
   * modeConfig must be object with the following properties:
   * modes {array} containing all of the named modes the directive can transform into. Each mode object must have the following properties
   *  - name {string} the name of this mode
   *  - template {string|function} the template string for this mode or
   *                               the a function that will be passed the directive instance's compile phase
   *                               $element, $attrs arguments which must return a string
   *  - templateUrl {string} an alternative to template that specifies the url to fetch the template from
   * //TODO: support wait for promise or Rx.Observable to compile the link functions, passing the result value as the 3rd param. This could be done per template so that some could be lazily loaded on need for it
   */
  return function (config) {
    assertValidConfig(config);

    var MODES = Object.create(null);

    for (var iM = 0, length = config.modes.length; iM < length; iM++) {
      assertValidMode(MODES, config.modes[iM]);
      Object.defineProperty(MODES, config.modes[iM].name.toUpperCase(), {
        enumerable: true,
        value: config.modes[iM].name
      });
    }

    Object.defineProperty(TransformerCompiler, 'MODES', {
      value: MODES
    });

    return TransformerCompiler;

    function TransformerCompiler($element, $attrs) {
      return {
        pre: function preLink($scope, $element, $attrs, controller) {
          var vm;
          var linkPromises = {};
          var defaultMode = null;
          var modeSubject = new Subject();
          var cancelCleanup = $scope.$on('$destroy', cleanup);

          var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

          if (config.controllerAs && config.bindToController) {
            vm = $scope[config.controllerAs];
          } else {
            vm = $scope;
          }

          // need to support direct configuration of the controllers. currently assigns to the first one only.
          if (isArray(controller) && controller.length > 0) {
            controller[0].$changeMode = $changeMode;
          } else if (controller) {
            controller.$changeMode = $changeMode;
          }

          //initialize modes
          for (var i = 0, modesLength = config.modes.length; i < modesLength; i++) {
            var mode = config.modes[i];

            if (isFunction(mode.compileOnPromise)) {
              linkPromises[mode.name] = mode.compileOnPromise($scope, $element, $attrs).then(function (modeInternal) {
                return function (resolvedValue) {
                  return initializeLink(modeInternal, resolvedValue);
                }
              }(mode));
            } else {
              linkPromises[mode.name] = initializeLink(mode);
            }

            if (mode.defaultMode) {
              defaultMode = mode.name;
              //console.log('default config mode ' + defaultMode);
            }
          }


          if ($attrs.defaultMode) {
            if ($attrs.defaultMode.indexOf('{{') === -1) {
              defaultMode = $attrs.defaultMode;
              //console.log('default template mode ' + defaultMode);
            } else {
              throw new Error('TransformerDirectiveFactory default mode must be a normal string. It cannot be bound with angular.')
            }
          }

          if (!vm.currentMode && defaultMode) {
            vm.currentMode = defaultMode;
          }

          var modeSubscription = modeSubject
            .startWith(vm.currentMode)
            .filter(filterInvalidModes)
            .distinctUntilChanged()
            .switchMap(observeModePromises)
            .subscribe($scope.$bindSafeApply(function (linkFn) {
              $log.debug('TransformerDirective: changing mode to', vm.currentMode);
              updateTemplate(linkFn, $scope, $element);
            }));

          var cancelModeObserve = $scope.$watch(function () {
            return vm.currentMode;
          }, function (newValue, oldValue) {
            if (newValue && (newValue !== oldValue)) {
              $changeMode(newValue);
            }
          });

          function $changeMode(mode) {
            if (vm.currentMode !== mode) {
              vm.currentMode = mode;
            }
            modeSubject.next(mode);
          }

          function filterInvalidModes(mode) {
            return mode && mode !== null && MODES[mode.toUpperCase()];
          }

          function cleanup() {
            isFunction(cancelModeObserve) && cancelModeObserve();
            modeSubscription && isFunction(modeSubscription.unsubscribe) && modeSubscription.unsubscribe();
          }

          function observeModePromises(mode) {
            //console.log('changing mode - deferred:', mode, linkPromises[mode]);
            if (linkPromises[mode]) {
              //console.log('changing mode - resolved:', mode);
              return Observable.fromPromise(linkPromises[mode]);
            } else {
              console.warn('valid modes:', TransformerCompiler.MODES);
              throw new Error('TransformerCompiler.$changeMode requires a valid mode:');
            }
          }

          function initializeLink(mode, resolvedValue) {
            if (isString(mode.template) || isFunction(mode.template)) {
              return Promise.resolve(initLinkFn(mode.template, $element, $attrs, resolvedValue));
            } else if (mode.templateUrl) {
              //TODO: associate this promise with this mode and debounce any requests to transform into this mode until this promise resolves
              return $templateRequest(mode.templateUrl).then(function (template) {
                return initLinkFn(template, $element, $attrs, resolvedValue);
              });
            }
          }

          function updateTemplate(linkFn, $scope, $element) {
            //$element.empty();


            var thisChangeId = ++changeCounter;
            var newScope = $scope.$new();

            var clonedElement = linkFn(newScope, function (clonedElement) {
              if (thisChangeId !== changeCounter) return;

              cleanupPreviousModeContent();
              $animate.enter(clonedElement, $element, null);

              //$element.append(clonedElement);
              //$element.replaceWith(clonedElement);
            });

            currentScope = newScope;
            currentElement = clonedElement;

            currentScope.$emit('$modeChanged', $scope.mode);

          }

          /**
           * invokes the template function with the directive's $element and $attrs parameters.
           * @param templateFn
           * @param $element
           * @param $attrs
           * @param resolvedValue
           * @returns {*}
           */
          function initLinkFn(templateFn, $element, $attrs, resolvedValue) {
            var errorMessage = 'provided invalid template. It must be a template string or a function returning a string';
            var result;
            if (isString(templateFn)) {
              result = templateFn;
            } else if (isFunction(templateFn)) {
              result = templateFn($element, $attrs, resolvedValue);
            } else {
              throw new Error(errorMessage);
            }

            if (result === '') {
              return $compile(emptyTemplate);
            } else if (isString(result)) {
              return $compile(result);
            } else {
              throw new Error(errorMessage);
            }
          }

          function cleanupPreviousModeContent() {
            if (previousElement) {
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).then(function () {
                previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          }
        },
        post: function postLink($scope, $element, $attrs, controller) {
        }
      };
    }
  };

  function assertValidConfig(config) {
    if (!isObject(config)) {
      throw new Error('TransformerDirectiveFactory: configuration parameter must be an object! Received:', config);
    }

    if (!isArray(config.modes)) {
      throw new Error('TransformerDirectiveFactory: configuration object must have a "modes" property containing an array');
    }
  }

  function assertValidMode(MODES, mode) {
    if (!isObject(mode) || !isString(mode.name) || (!isString(mode.templateUrl) && !isString(mode.template) && !isFunction(mode.template))) {
      throw new Error('TransformerDirectiveFactory: Invalid mode object. Must have a name and either a template or templateUrl property! Received:', mode);
    }

    if (isDefined(MODES[mode.name])) {
      throw new Error('TransformerDirectiveFactory: Mode configuration contains duplicate modes!:', mode);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/transformer-directive/TransformerDirectiveFactory.js